module.exports = __webpack_public_path__ + "static/media/WaveCharacteristics.fb3ba3b8.svg";